module.exports = __webpack_public_path__ + "img/1_3@2x.114ef1d6.png";